import React, { useCallback, useEffect, useRef, useState } from 'react';
import Tab2Content from './Tab2Content';

function Tab2({ addModalType,  setModalType ,set_menuVisiable, screenArg }) {
    useEffect(() => {
    }, []);

    return <Tab2Content addModalType={addModalType}  setModalType={setModalType} screenArg={screenArg} />;
}

export default Tab2;
